

import { useContext } from "react"
import { LocaleContext } from "../../context/context"
import { mapLocale } from "../../utils/mapping"
import { useUrl } from "../../hooks/layout/useUrl"

export const useLink = (slug: string): string | null => {
  const { locale } = useContext(LocaleContext)
  const siteUrl = useUrl()

  const prefix = mapLocale[locale] || "in/en" 

  if (!slug && slug !== "") return null
  if (slug === "/") return `${siteUrl}/${prefix}/`

  const normalizedSlug = slug.startsWith("/") ? slug.slice(1) : slug
  const finalSlug = normalizedSlug.endsWith("/")
    ? normalizedSlug
    : `${normalizedSlug}/`

  return `/${prefix}/${decodeURI(finalSlug)}`
}
